import React from "react";
import { IMAGES } from "../mock";

/**
 * Great North Advantage logo (official artwork supplied by client).
 * On light backgrounds the white JPG background is blended away with mix-blend-multiply.
 * On dark backgrounds (`dark`) it sits inside a white panel.
 */
const Logo = ({ className = "", dark = false }) => (
  <div className={`flex items-center ${className}`} aria-label="Great North Advantage">
    {dark ? (
      <div className="inline-block rounded-2xl bg-white px-4 py-3">
        <img src={IMAGES.logo} alt="Great North Advantage" className="h-16 w-auto" data-testid="site-logo" />
      </div>
    ) : (
      <img src={IMAGES.logo} alt="Great North Advantage" className="h-16 w-auto lg:h-[76px]" data-testid="site-logo" />
    )}
  </div>
);

export default Logo;
